import PrintQueueEntry from '../../../../types/api/print-queue-entry'

interface BuildMoveToDayReorderPayloadParams {
    machineEntries: PrintQueueEntry[]
    selectedEntries: PrintQueueEntry[]
    targetPlannedPrintDate: string
}

export function buildMoveToDayReorderPayload({
    machineEntries,
    selectedEntries,
    targetPlannedPrintDate,
}: BuildMoveToDayReorderPayloadParams): { documentId: string; sort: number }[] {
    const selectedIds = new Set(selectedEntries.map(entry => entry.documentId))
    const sortedEntries = machineEntries.slice().sort((a, b) => a.sort - b.sort)
    const nextSelectedEntries = selectedEntries
        .slice()
        .sort((a, b) => a.sort - b.sort)
        .map(entry => ({
            ...entry,
            plannedPrintDate: targetPlannedPrintDate,
        }))

    const entriesWithoutSelected = sortedEntries.filter(entry => !selectedIds.has(entry.documentId))
    const targetIndexes = entriesWithoutSelected.reduce<number[]>((acc, entry, index) => {
        if (entry.plannedPrintDate === targetPlannedPrintDate) {
            acc.push(index)
        }

        return acc
    }, [])

    const insertAt =
        targetIndexes.length > 0 ? targetIndexes[targetIndexes.length - 1] + 1 : entriesWithoutSelected.length
    const nextOrder = entriesWithoutSelected.slice()

    nextOrder.splice(insertAt, 0, ...nextSelectedEntries)

    return nextOrder.map((entry, index) => ({
        documentId: entry.documentId,
        sort: index,
    }))
}

export function buildReorderPayloadFromEntries(entries: PrintQueueEntry[]) {
    return entries.map((entry, index) => ({
        documentId: entry.documentId,
        sort: index,
    }))
}

export function mergeScopedEntriesIntoMachineQueue(
    machineEntries: PrintQueueEntry[],
    scopedEntries: PrintQueueEntry[]
): PrintQueueEntry[] {
    const scopedIds = new Set(scopedEntries.map(entry => entry.documentId))
    const sortedMachineEntries = machineEntries.slice().sort((a, b) => a.sort - b.sort)
    const nextEntries = sortedMachineEntries.slice()
    let scopedIndex = 0

    for (let index = 0; index < nextEntries.length; index++) {
        if (scopedIds.has(nextEntries[index].documentId)) {
            nextEntries[index] = scopedEntries[scopedIndex]
            scopedIndex += 1
        }
    }

    return nextEntries
}

export function buildScopedReorderPayload(params: {
    machineEntries: PrintQueueEntry[]
    scopedEntries: PrintQueueEntry[]
}): { documentId: string; sort: number }[] {
    const { machineEntries, scopedEntries } = params

    return buildReorderPayloadFromEntries(
        mergeScopedEntriesIntoMachineQueue(machineEntries, scopedEntries)
    )
}
